import { Component,OnInit } from '@angular/core';
import { PatientServiceService } from '../../services/PatientService.service';

@Component({
  selector: 'app-other',
  templateUrl: './other.component.html',
  styleUrls: ['./other.component.css']
})

export class PaOtherComponent implements OnInit {
  htmlView: boolean = true;
  errHeader: string;
  errMessage: string[] = [];
  medicines: string[];
  vitamins: string[];
  surgicalHistories: string[];
  allergies: string[];
  currentList: any[];
  showOverlay: boolean;
  index: string = "1";
  headerText: string;
  currentListShow: boolean = false;
  activeElementCode: string = "1";
  constructor(private _service: PatientServiceService) {}

  ngOnInit() {
    this.showOverlay = true;
    this.getPatientOtherData();
  }

  getPatientOtherData() {
    this._service.getPatientOtherData().subscribe((data) => {
      this.medicines = data["medicines"];
      this.vitamins = data["vitamins"];
      this.allergies = data["allergies"];
      this.surgicalHistories = data["surgicalHistories"];
      this.showOverlay = false;
      this.changeDiv('1');
    }, err => {
      if (err.status === 400) {
        this.errHeader = 'Server Exception';
        this.errMessage = err.error;
        this.htmlView = false;
      }
      this.showOverlay = false;
    }, () => {
      this.htmlView = true;
      this.showOverlay = false;
    });
  }

  changeDiv(index) {
    if (index == "1") {
      this.activeElementCode = index;
      this.currentList = this.medicines;
      this.headerText = "List of Other Medicine";
      this.checkList();
    }
    if (index == "2") {
      this.activeElementCode = index;
      this.currentList = this.vitamins;
      this.headerText = "List of Vitamins";
      this.checkList();
    }
    if (index == "3") {
      this.activeElementCode = index;
      this.currentList = this.allergies;
      this.headerText = "List of Allergies";
    }
    if (index == "4") {
      this.activeElementCode = index;
      this.currentList = this.surgicalHistories;
      this.headerText = "List of Surgical History";
      this.checkList();
    }
  }

  checkList() {
    this.currentListShow = this.currentList.length < 1 ? true : false;
  }


}
